import { useMemo } from "react";

// Groups the flat paging/action props ModelTaskTable receives into the
// shapes VirtualModelTaskRows and ModelTaskRow actually consume.
const useModelTaskChildProps = ({
	onRequestDelete,
	handleCopy,
	handleCopyTaskQuestion,
	modelId,
	customCaptions,
	access,
	totalTaskCount,
	fetchData,
	hasPreviousPage,
	isFetchingPreviousPage,
	isFetchPreviousPageError,
	fetchPreviousPage,
	hasNextPage,
	isFetchingNextPage,
	isFetchNextPageError,
	fetchNextPage,
}) => {
	const rowProps = useMemo(
		() => ({
			onRequestDelete,
			handleCopy,
			handleCopyTaskQuestion,
			modelId,
			customCaptions,
			access,
			totalTaskCount,
			fetchData,
		}),
		[
			access,
			customCaptions,
			fetchData,
			handleCopy,
			handleCopyTaskQuestion,
			modelId,
			onRequestDelete,
			totalTaskCount,
		]
	);
	const previousPage = useMemo(
		() => ({
			hasPage: hasPreviousPage,
			isFetching: isFetchingPreviousPage,
			isError: isFetchPreviousPageError,
			fetch: fetchPreviousPage,
		}),
		[fetchPreviousPage, hasPreviousPage, isFetchPreviousPageError, isFetchingPreviousPage]
	);
	const nextPage = useMemo(
		() => ({
			hasPage: hasNextPage,
			isFetching: isFetchingNextPage,
			isError: isFetchNextPageError,
			fetch: fetchNextPage,
		}),
		[fetchNextPage, hasNextPage, isFetchNextPageError, isFetchingNextPage]
	);

	return { rowProps, previousPage, nextPage };
};

export default useModelTaskChildProps;
